import { render, staticRenderFns } from "./TableLocationComponent.vue?vue&type=template&id=c137fde8&"
import script from "./TableLocationComponent.vue?vue&type=script&lang=js&"
export * from "./TableLocationComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableLocationComponent.vue?vue&type=style&index=0&id=c137fde8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports